import Vue from "vue";
import Router from "vue-router";
// 最新的首页和换课列表
import index from "../views/index/index.vue";
import changeCourse from "../views/changeCourse/index.vue";

import baseUtil from "@/utils/base";

Vue.use(Router);

const router = new Router({
  scrollBehavior: (to, from) => (to.name !== from.name ? { y: 0 } : ""),
  routes: [
    {
      path: "/",
      name: "index",
      component: index,
      meta: {},
    },
    {
      path: "/changeCourse",
      name: "changeCourse",
      component: changeCourse,
      meta: {},
    },
    {
      path: "*",
      redirect: "/",
    },
  ],
});

router.beforeEach((to, from, next) => {
  baseUtil.setTitle(to.meta.title);
  next();
});

export default router;
